const trustPoints = [
  {
    icon: 'ri-file-list-3-line',
    title: 'Clear quotes with no surprises',
    desc: 'We provide detailed, transparent quotes upfront. No hidden costs, no last-minute changes.',
    cardBg: 'bg-orange-50',
    iconBg: 'bg-orange-100',
    iconColor: 'text-orange-500',
    numColor: 'text-orange-100',
  },
  {
    icon: 'ri-time-line',
    title: 'Reliable and on-time service',
    desc: 'We show up when we say we will and finish on schedule. Your time matters to us.',
    cardBg: 'bg-sky-50',
    iconBg: 'bg-sky-100',
    iconColor: 'text-sky-500',
    numColor: 'text-sky-100',
  },
  {
    icon: 'ri-brush-line',
    title: 'Clean and professional finishes',
    desc: 'Every job is completed to the highest standard with meticulous attention to detail.',
    cardBg: 'bg-emerald-50',
    iconBg: 'bg-emerald-100',
    iconColor: 'text-emerald-500',
    numColor: 'text-emerald-100',
  },
  {
    icon: 'ri-home-heart-line',
    title: 'Respect for your home',
    desc: 'We treat your property as if it were our own — careful, clean, and considerate.',
    cardBg: 'bg-violet-50',
    iconBg: 'bg-violet-100',
    iconColor: 'text-violet-500',
    numColor: 'text-violet-100',
  },
];

export default function TrustSection() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="text-center mb-14">
          <span className="inline-block text-[#2D2D2D] text-sm font-semibold tracking-widest uppercase mb-3">Why Choose Us</span>
          <h2 className="text-4xl md:text-5xl font-black text-gray-900 mb-4 tracking-tight">
            Painting made simple<br />and stress-free
          </h2>
          <p className="text-gray-500 text-lg max-w-xl mx-auto">
            We take the hassle out of home improvement so you can enjoy the results.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {trustPoints.map((point, i) => (
            <div
              key={point.title}
              className={`relative p-7 rounded-2xl ${point.cardBg} group hover:-translate-y-1 transition-all duration-300`}
            >
              <div className={`absolute top-5 right-5 ${point.numColor} font-black text-5xl leading-none select-none`}>
                {String(i + 1).padStart(2, '0')}
              </div>
              <div className={`w-12 h-12 flex items-center justify-center rounded-xl ${point.iconBg} mb-5`}>
                <i className={`${point.icon} ${point.iconColor} text-xl`} />
              </div>
              <h3 className="font-bold text-gray-900 text-base mb-2 leading-snug">{point.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed">{point.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
